<p>closed-batch-details-tape-preview works!</p>
